import {BaseContainerModel} from '../base-container.model';
import {bl_asv_consultation_checklist_image_line_RowClass} from '../../dbschema';

export class AsvConsultationChecklistImageLineModel extends BaseContainerModel {
    bl_asv_consultation_checklist_image_line: bl_asv_consultation_checklist_image_line_RowClass = new bl_asv_consultation_checklist_image_line_RowClass();
}
